/** Years offered in event-year pickers: next year (events are set up ahead) back to the first event in the system. */
export function eventYearOptions() {
    const years = [];
    for (let year = new Date().getFullYear() + 1; year >= 2023; year--) {
        years.push(year);
    }
    return years;
}
